import React from 'react';
import { t } from '../../../locales/i18n';
import * as R from 'ramda';
import { BoothTicket } from '../../../types/ticket';
import styled from 'styled-components';
import { sizes } from '../../../themes/sizes';
import { colors, breakpoints } from '@nextinq/ui-toolkit';

const Container = styled.section`
  display: grid;
  align-items: center;
  justify-items: center;
  gap: ${sizes.margins.normal};
  h2 {
    color: ${colors.base.secondary};
    font-size: ${sizes.fonts.massive};
  }
  @media ${breakpoints.max.smallPhone} {
    h4,
    h5 {
      display: none;
    }
  }
`;

const PreviousTickets = styled.span`
  padding-left: ${sizes.margins.normal};
`;

const PreviousTicketWrapper = styled.span`
  &:after {
    content: ', ';
  }
`;

interface PreviousTicketProps {
  ticket: BoothTicket;
}

function PreviousTicket(props: PreviousTicketProps) {
  const { ticket } = props;
  if (!ticket) {
    return null;
  }
  return (
    <PreviousTicketWrapper>{ticket.formattedNumber}</PreviousTicketWrapper>
  );
}

interface CurrentTicketProps {
  ticket: BoothTicket | null;
  previousTickets: Array<BoothTicket>;
}

export function CurrentTicket(props: CurrentTicketProps) {
  const currentTicketNumber = props.ticket
    ? props.ticket.formattedNumber
    : '--';
  const previousTickets = R.take(3)(props.previousTickets);
  return (
    <Container>
      <h4>{t('currentTicket.title')}</h4>
      <h2>{currentTicketNumber}</h2>
      <h5>
        {!R.isEmpty(previousTickets) && `${t('currentTicket.previousTicket')}`}
        <PreviousTickets>
          {previousTickets.map((t: BoothTicket) => (
            <PreviousTicket ticket={t} key={t.uuid} />
          ))}
        </PreviousTickets>
        ...
      </h5>
    </Container>
  );
}
